import { Navigate, useLocation } from 'react-router-dom';
import { tokenStore } from '@/api/client';

interface Props {
  children: React.ReactNode;
  kind?: 'user' | 'merchant';
}

export function ProtectedRoute({ children }: Props) {
  const loc = useLocation();
  const hasToken = !!tokenStore.get();

  console.log('[ProtectedRoute] path=', loc.pathname, 'hasToken=', hasToken);

  if (!hasToken) {
    console.log('[ProtectedRoute] BOUNCING to /login (no token)');
    return <Navigate to="/login" replace state={{ from: loc }} />;
  }

  console.log('[ProtectedRoute] ALLOWING through');
  return <>{children}</>;
}
